// Language translations for entire app
// This file contains all UI text in English, Hindi, and Marathi

export const translations = {
  English: {
    // Navigation & Headers
    "Kisaan AI": "Kisaan AI",
    "Smart Farming Assistant": "Smart Farming Assistant",
    "AI Recommendation": "AI Recommendation",
    "Smart Farming Analysis": "Smart Farming Analysis",

    // Language Selection
    "English": "English",
    "Hindi": "Hindi",
    "Marathi": "Marathi",

    // AskTab - Questions
    "Which crop are you growing?": "Which crop are you growing?",
    "What issue are you facing?": "What issue are you facing?",
    "What is your soil type? (loamy, sandy, clay, etc.)": "What is your soil type? (loamy, sandy, clay, etc.)",
    "Soil pH level? (4.0-9.0)": "Soil pH level? (4.0-9.0)",
    "Soil Nitrogen (N) in ppm?": "Soil Nitrogen (N) in ppm?",
    "Soil Phosphorus (P) in ppm?": "Soil Phosphorus (P) in ppm?",
    "Soil Potassium (K) in ppm?": "Soil Potassium (K) in ppm?",
    "Water availability?": "Water availability?",
    "What is your budget range?": "What is your budget range?",
    "Describe your farm problem briefly": "Describe your farm problem briefly",

    // AskTab - Hints
    "If unsure, common soil types: loamy (fertile), sandy (drains well), clay (holds water), silt (fine particles)": "If unsure, common soil types: loamy (fertile), sandy (drains well), clay (holds water), silt (fine particles)",
    "pH 6.0-7.0 is ideal for most crops. If unknown, leave blank or click \"Skip\"": "pH 6.0-7.0 is ideal for most crops. If unknown, leave blank or click \"Skip\"",
    "Typical range: 5-50 ppm. If unknown, leave blank or click \"Skip\"": "Typical range: 5-50 ppm. If unknown, leave blank or click \"Skip\"",
    "Or specify in liters/day or mm/week. Low: <5L/day, Moderate: 5-20L/day, High: >20L/day": "Or specify in liters/day or mm/week. Low: <5L/day, Moderate: 5-20L/day, High: >20L/day",

    // AskTab - Options
    "Wheat": "Wheat",
    "Rice": "Rice",
    "Cotton": "Cotton",
    "Tomato": "Tomato",
    "Onion": "Onion",
    "Yellow Leaves": "Yellow Leaves",
    "Low Growth": "Low Growth",
    "Pest Problem": "Pest Problem",
    "Dry Soil": "Dry Soil",
    "Low Yield": "Low Yield",
    "Low": "Low",
    "Moderate": "Moderate",
    "High": "High",
    "Medium": "Medium",
    "Loamy": "Loamy",
    "Sandy": "Sandy",
    "Clay": "Clay",
    "Silt": "Silt",
    "Not sure": "Not sure",
    "Skip": "Skip",

    // AskTab - Actions
    "Type your answer...": "Type your answer...",
    "Send": "Send",
    "Listen": "🔊 Listen",
    "Fetching location...": "Fetching location...",
    "Location unavailable": "Location unavailable",

    // Loading Messages
    "Analyzing soil...": "🌱 Analyzing soil...",
    "Checking farming conditions...": "🌦️ Checking farming conditions...",
    "Generating AI recommendations...": "🤖 Generating AI recommendations...",
    "AI recommendations generated successfully.": "✅ AI recommendations generated successfully.",

    // Crop Validation
    "Crop Suitability Alert": "⚠️ Crop Suitability Alert",
    "Crop is Well-Suited": "✅ Crop is Well-Suited",
    "Region Information": "📍 Region Information:",
    "Climate Zone": "Climate Zone",
    "Annual Rainfall": "Annual Rainfall",
    "Soil Type": "Soil Type",
    "Better Crop Options for": "💡 Better Crop Options for",
    "Recommended for this region": "Recommended for this region",
    "Tip": "📚 Tip",
    "These crops are naturally suited to": "These crops are naturally suited to",
    "climate and soil. Growing them will likely give you better yields with less effort.": "climate and soil. Growing them will likely give you better yields with less effort.",

    // Results Section
    "Overall Analysis": "Overall Analysis",
    "Quantity": "Quantity",
    "Fertilizers": "Fertilizers",
    "Recommendations": "Recommendations",

    // Navigation
    "Home": "Home",
    "History": "History",
    "Ask": "Ask",
    "Weather": "Weather",
    "Market": "Market",
    "Tips": "Tips",
    "Login": "Login",
    "Signup": "Signup",
    "Logout": "Logout",

    // Messages
    "Failed to generate AI response.": "Failed to generate AI response.",
    "Success": "Success",
    "Error": "Error",
  },

  Hindi: {
    // Navigation & Headers
    "Kisaan AI": "किसान एआई",
    "Smart Farming Assistant": "स्मार्ट कृषि सहायक",
    "AI Recommendation": "एआई सिफारिश",
    "Smart Farming Analysis": "स्मार्ट कृषि विश्लेषण",

    // Language Selection
    "English": "English",
    "Hindi": "हिंदी",
    "Marathi": "Marathi",

    // AskTab - Questions
    "Which crop are you growing?": "🌾 आप कौन सी फसल उगा रहे हैं?",
    "What issue are you facing?": "🍂 आप किस समस्या का सामना कर रहे हैं?",
    "What is your soil type? (loamy, sandy, clay, etc.)": "🌱 आपकी मिट्टी का प्रकार क्या है? (दोमट, रेतीली, चिकनी, आदि)",
    "Soil pH level? (4.0-9.0)": "🧪 मिट्टी का पीएच स्तर? (4.0-9.0)",
    "Soil Nitrogen (N) in ppm?": "🟢 मिट्टी में नाइट्रोजन (N) पीपीएम में?",
    "Soil Phosphorus (P) in ppm?": "🟡 मिट्टी में फास्फोरस (P) पीपीएम में?",
    "Soil Potassium (K) in ppm?": "🟠 मिट्टी में पोटैशियम (K) पीपीएम में?",
    "Water availability?": "💧 पानी की उपलब्धता कैसी है?",
    "What is your budget range?": "💰 आपका बजट कितना है?",
    "Describe your farm problem briefly": "📝 अपनी कृषि समस्या का संक्षेप में वर्णन करें",

    // AskTab - Hints
    "If unsure, common soil types: loamy (fertile), sandy (drains well), clay (holds water), silt (fine particles)": "अगर अनिश्चित हैं, तो सामान्य मिट्टी के प्रकार: दोमट (उर्वर), रेतीली (अच्छी जल निकासी), चिकनी (पानी रोकती), सिल्ट (बारीक कण)",
    "pH 6.0-7.0 is ideal for most crops. If unknown, leave blank or click \"Skip\"": "अधिकांश फसलों के लिए pH 6.0-7.0 आदर्श है। अगर अज्ञात है, तो खाली छोड़ दें या \"छोड़ें\" पर क्लिक करें",
    "Typical range: 5-50 ppm. If unknown, leave blank or click \"Skip\"": "सामान्य रेंज: 5-50 पीपीएम। अगर अज्ञात है, तो खाली छोड़ दें या \"छोड़ें\" पर क्लिक करें",
    "Or specify in liters/day or mm/week. Low: <5L/day, Moderate: 5-20L/day, High: >20L/day": "या लीटर/दिन या मिमी/सप्ताह में निर्दिष्ट करें। कम: <5L/दिन, मध्यम: 5-20L/दिन, उच्च: >20L/दिन",

    // AskTab - Options
    "Wheat": "गेहूं",
    "Rice": "चावल",
    "Cotton": "कपास",
    "Tomato": "टमाटर",
    "Onion": "प्याज",
    "Yellow Leaves": "पीली पत्तियां",
    "Low Growth": "कम वृद्धि",
    "Pest Problem": "कीट समस्या",
    "Dry Soil": "सूखी मिट्टी",
    "Low Yield": "कम पैदावार",
    "Low": "कम",
    "Moderate": "मध्यम",
    "High": "अधिक",
    "Medium": "मध्यम",
    "Loamy": "दोमट",
    "Sandy": "रेतीली",
    "Clay": "चिकनी",
    "Silt": "सिल्ट",
    "Not sure": "पता नहीं",
    "Skip": "छोड़ें",

    // AskTab - Actions
    "Type your answer...": "अपना उत्तर लिखें...",
    "Send": "भेजें",
    "Listen": "🔊 सुनें",
    "Fetching location...": "स्थान प्राप्त किया जा रहा है...",
    "Location unavailable": "स्थान उपलब्ध नहीं है",

    // Loading Messages
    "Analyzing soil...": "🌱 मिट्टी का विश्लेषण किया जा रहा है...",
    "Checking farming conditions...": "🌦️ कृषि परिस्थितियों की जांच हो रही है...",
    "Generating AI recommendations...": "🤖 एआई सिफारिशें तैयार की जा रही हैं...",
    "AI recommendations generated successfully.": "✅ एआई सिफारिशें सफलतापूर्वक तैयार हो गईं।",

    // Crop Validation
    "Crop Suitability Alert": "⚠️ फसल उपयुक्तता चेतावनी",
    "Crop is Well-Suited": "✅ यह फसल उपयुक्त है",
    "Region Information": "📍 क्षेत्र की जानकारी:",
    "Climate Zone": "जलवायु क्षेत्र",
    "Annual Rainfall": "वार्षिक वर्षा",
    "Soil Type": "मिट्टी का प्रकार",
    "Better Crop Options for": "💡 इसके लिए बेहतर फसल विकल्प",
    "Recommended for this region": "इस क्षेत्र के लिए अनुशंसित",
    "Tip": "📚 सुझाव",
    "These crops are naturally suited to": "ये फसलें स्वाभाविक रूप से उपयुक्त हैं",
    "climate and soil. Growing them will likely give you better yields with less effort.": "जलवायु और मिट्टी के लिए। इन्हें उगाने से कम मेहनत में बेहतर उत्पादन मिलेगा।",

    // Results Section
    "Overall Analysis": "समग्र विश्लेषण",
    "Quantity": "मात्रा",
    "Fertilizers": "उर्वरक",
    "Recommendations": "सिफारिशें",

    // Navigation
    "Home": "होम",
    "History": "इतिहास",
    "Ask": "पूछें",
    "Weather": "मौसम",
    "Market": "बाजार",
    "Tips": "सुझाव",
    "Login": "लॉगिन",
    "Signup": "साइन अप",
    "Logout": "लॉगआउट",

    // Messages
    "Failed to generate AI response.": "एआई प्रतिक्रिया उत्पन्न करने में विफल।",
    "Success": "सफलता",
    "Error": "त्रुटि",
  },

  Marathi: {
    // Navigation & Headers
    "Kisaan AI": "किसान एआय",
    "Smart Farming Assistant": "स्मार्ट शेती सहाय्यक",
    "AI Recommendation": "एआय शिफारस",
    "Smart Farming Analysis": "स्मार्ट शेती विश्लेषण",

    // Language Selection
    "English": "English",
    "Hindi": "Hindi",
    "Marathi": "मराठी",

    // AskTab - Questions
    "Which crop are you growing?": "🌾 आपण कोणते पीक घेत आहात?",
    "What issue are you facing?": "🍂 आपण कोणत्या समस्येला सामोरे जात आहात?",
    "What is your soil type? (loamy, sandy, clay, etc.)": "🌱 तुमच्या मातीचा प्रकार काय आहे? (दुमट, वाळू, चिकण, इ.)",
    "Soil pH level? (4.0-9.0)": "🧪 मातीचा pH स्तर? (4.0-9.0)",
    "Soil Nitrogen (N) in ppm?": "🟢 मातीत नायट्रोजन (N) ppm मध्ये?",
    "Soil Phosphorus (P) in ppm?": "🟡 मातीत फॉस्फरस (P) ppm मध्ये?",
    "Soil Potassium (K) in ppm?": "🟠 मातीत पोटॅशियम (K) ppm मध्ये?",
    "Water availability?": "💧 पाण्याची उपलब्धता कशी आहे?",
    "What is your budget range?": "💰 तुमचा बजेट किती आहे?",
    "Describe your farm problem briefly": "📝 तुमच्या शेती समस्येचे थोडक्यात वर्णन करा",

    // AskTab - Hints
    "If unsure, common soil types: loamy (fertile), sandy (drains well), clay (holds water), silt (fine particles)": "अनिश्चित असल्यास, सामान्य मातीचे प्रकार: दुमट (उर्वर), वाळू (चांगली पाणी वाहते), चिकण (पाणी साठवते), सिल्ट (बारीक कण)",
    "pH 6.0-7.0 is ideal for most crops. If unknown, leave blank or click \"Skip\"": "बहुतांश पिकांसाठी pH 6.0-7.0 आदर्श आहे. अज्ञात असल्यास, रिकामे सोडा किंवा \"वगळा\" वर क्लिक करा",
    "Typical range: 5-50 ppm. If unknown, leave blank or click \"Skip\"": "सामान्य श्रेणी: 5-50 ppm. अज्ञात असल्यास, रिकामे सोडा किंवा \"वगळा\" वर क्लिक करा",
    "Or specify in liters/day or mm/week. Low: <5L/day, Moderate: 5-20L/day, High: >20L/day": "किंवा लिटर/दिवस किंवा मिमी/आठवड्यात निर्दिष्ट करा. कमी: <5L/दिवस, मध्यम: 5-20L/दिवस, जास्त: >20L/दिवस",

    // AskTab - Options
    "Wheat": "गहू",
    "Rice": "तांदूळ",
    "Cotton": "कापूस",
    "Tomato": "टोमॅटो",
    "Onion": "कांदा",
    "Yellow Leaves": "पिवळी पाने",
    "Low Growth": "कमी वाढ",
    "Pest Problem": "कीड समस्या",
    "Dry Soil": "कोरडी माती",
    "Low Yield": "कमी उत्पादन",
    "Low": "कमी",
    "Moderate": "मध्यम",
    "High": "जास्त",
    "Medium": "मध्यम",
    "Loamy": "दुमट",
    "Sandy": "वाळू",
    "Clay": "चिकण",
    "Silt": "सिल्ट",
    "Not sure": "माहीत नाही",
    "Skip": "वगळा",

    // AskTab - Actions
    "Type your answer...": "तुमचे उत्तर लिहा...",
    "Send": "पाठवा",
    "Listen": "🔊 ऐका",
    "Fetching location...": "स्थान मिळवत आहे...",
    "Location unavailable": "स्थान उपलब्ध नाही",

    // Loading Messages
    "Analyzing soil...": "🌱 मातीचे विश्लेषण करत आहे...",
    "Checking farming conditions...": "🌦️ शेतीची परिस्थिती तपासत आहे...",
    "Generating AI recommendations...": "🤖 एआय शिफारसी तयार करत आहे...",
    "AI recommendations generated successfully.": "✅ एआय शिफारसी यशस्वीरित्या तयार झाल्या.",

    // Crop Validation
    "Crop Suitability Alert": "⚠️ पीक योग्यतेची सूचना",
    "Crop is Well-Suited": "✅ हे पीक योग्य आहे",
    "Region Information": "📍 प्रदेश माहिती:",
    "Climate Zone": "हवामान क्षेत्र",
    "Annual Rainfall": "वार्षिक पाऊस",
    "Soil Type": "मातीचा प्रकार",
    "Better Crop Options for": "💡 यासाठी चांगले पीक पर्याय",
    "Recommended for this region": "या प्रदेशासाठी शिफारस केलेले",
    "Tip": "📚 सूचना",
    "These crops are naturally suited to": "ही पिके नैसर्गिकरित्या उपयुक्त आहेत",
    "climate and soil. Growing them will likely give you better yields with less effort.": "हवामान आणि मातीसाठी. ती घेतल्यास कमी मेहनतीत जास्त उत्पादन मिळेल.",

    // Results Section
    "Overall Analysis": "संपूर्ण विश्लेषण",
    "Quantity": "प्रमाण",
    "Fertilizers": "खते",
    "Recommendations": "शिफारसी",

    // Navigation
    "Home": "होम",
    "History": "इतिहास",
    "Ask": "विचारा",
    "Weather": "हवामान",
    "Market": "बाजार",
    "Tips": "सल्ले",
    "Login": "लॉगिन",
    "Signup": "साइन अप",
    "Logout": "लॉग आउट",

    // Messages
    "Failed to generate AI response.": "एआय प्रतिसाद तयार करण्यात अयशस्वी.",
    "Success": "यशस्वी",
    "Error": "त्रुटी",
  },
};

// Helper function to get translation
export const t = (key, language = "English") => {
  return translations[language]?.[key] || translations.English[key] || key;
};